import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    theme="dark"
    className="toaster group"
    toastOptions={{
      classNames: {
        toast:
          "!rounded-card !border !border-fx-line !bg-fx-surface !text-fx-title !font-sans !text-sm !font-semibold !shadow-[0_10px_30px_rgba(0,0,0,0.7)]",
        icon: "!text-fx-red-icon",
      },
    }}
    style={
      {
        "--normal-bg": "var(--fx-surface)",
        "--normal-text": "var(--fx-title)",
        "--normal-border": "var(--fx-line)",
        "--border-radius": "16px",
      } as React.CSSProperties
    }
    {...props}
  />
);

export { Toaster };
